import { render } from "./Alignment.vue?vue&type=template&id=3f442409"
import script from "./Alignment.vue?vue&type=script&lang=js"
export * from "./Alignment.vue?vue&type=script&lang=js"
script.render = render

export default script